<template lang="pug">
    v-card(
        elevation="4"
        shaped
    )
        v-toolbar(dense)
            v-icon.mr-2 mdi-account
            v-toolbar-title Agents

        v-card-text
            v-tabs(grow show-arrows light v-model="currentTab")
                v-tab(v-for="tab in tabs" :key="tab.value" :href="'#' + tab.value")
                    | {{ tab.label }}

                v-tabs-items(v-model="currentTab")
                    v-tab-item(v-for="tab in tabs" :key="tab.value" :value="tab.value")
                        template(v-if="currentTab === 'overview'")
                            v-data-table(
                                :headers="overviewHeaders"
                                item-key="ownable_id"
                                :items="overviewReports"
                                show-expand
                                :single-expand="true"
                                style="margin-top: 15px;"
                            )

                                template(v-slot:item.overview_average_progress="{ item }")
                                    | {{ Math.round(item.overview_average_progress * 10) / 10 }}%

                                template(v-slot:item.overview_total_achieved="{ item }")
                                    | {{ item.overview_total_achieved}}/{{ item.overview_total_goals }}

                                template(v-slot:expanded-item="{ headers, item }")
                                    td(:colspan="headers.length")
                                        v-card(flat)
                                            v-card-text
                                                History(
                                                    :ownable-id="item.ownable_id"
                                                    ownable-type="user"
                                                )
                        template(v-else)
                            v-data-table(
                                :headers="headers"
                                item-key="ownable_id"
                                :items="reports"
                                show-expand
                                :single-expand="true"
                                style="margin-top: 15px;"
                            )

                                template(v-slot:item.average_progress="{ item }")
                                    | {{ Math.round(item.average_progress * 10) / 10 }}%

                                template(v-slot:item.goals="{ item }")
                                    .d-flex.flex-row.flex-wrap.justify-start.align-center
                                        div(v-for="(goal, index) in item.goal_data" :key="index" class="ma-1")
                                            GoalMenu(
                                                :goal="goalWithRecurringType(goal)"
                                                :goals="[goalWithRecurringType(goal)]"
                                            )

                                template(v-slot:item.total_achieved="{ item }")
                                    | {{ item.total_achieved}}/{{ item.total_goals }}

                                template(v-slot:expanded-item="{ headers, item }")
                                    td(:colspan="headers.length")
                                        v-card(flat)
                                            v-card-text
                                                History(
                                                    :force-recurring-type="currentTab"
                                                    :ownable-id="item.ownable_id"
                                                    ownable-type="user"
                                                )
</template>

<script lang="ts">
    import Vue from 'vue';

    // Components
    import TableFixedHeader from '@/components/shared/table_fixed_header.vue';
    import GoalMenu from "@/components/goals/user_goals/goal_menu.vue";
    import History from '@/components/dashboards/live/tabs/goals/historical.vue';

    // Data
    import { GetUserGoalsReport, GetUserGoalsOverviewReport } from "@/data";

    //Helpers
    import { isShowMore } from '@/helpers/show_more'

    export default Vue.extend({
        data() {
            return {
                currentTab: 'daily',
                headers: [
                    { text: 'Agent', value: 'user_full_name', class: 'header-class' },
                    { text: 'Current Progress', value: 'average_progress', class: 'header-class'},
                    { text: 'Active Goals', value: 'goals', class: 'header-class', sortable: false },
                    { text: 'Achieved', value: 'total_achieved', class: 'header-class'},
                ],
                isLoading: false,
                overviewHeaders: [
                    { text: 'Agent', value: 'user_full_name', class: 'header-class' },
                    { text: 'Average Progress', value: 'overview_average_progress', class: 'header-class'},
                    { text: 'Total Achieved', value: 'overview_total_achieved', class: 'header-class'},
                ],
                overviewReports: [],
                reports: [],
                showMore: false,
                tabs: [
                    { label: 'Overview', value: 'overview' },
                    { label: 'Daily', value: 'daily' },
                    { label: 'Weekly', value: 'weekly' },
                    { label: 'Monthly', value: 'monthly' },
                    { label: 'Quarterly', value: 'quarterly' },
                    { label: 'Yearly', value: 'yearly' },
                ],
            }
        },
        methods: {
            getUserGoalsOverview() {

                this.isLoading = true;

                GetUserGoalsOverviewReport().then((response) => {
                    if (response.Data?.user_goals_overview_reports?.length > 0) {
                        this.overviewReports = response.Data.user_goals_overview_reports;
                    }

                    this.isLoading = false;
                });
            },
            getUserGoalsReport() {
                const options = {
                    recurring_type: this.currentTab,
                }

                this.isLoading = true;

                GetUserGoalsReport(options).then((response) => {
                    if (response.Data?.user_goals_reports?.length > 0) {
                        this.reports = response.Data.user_goals_reports;
                    }

                    this.isLoading = false;
                });
            },
            goalWithRecurringType(goal){
                return {
                    ...goal,
                    recurring_type: this.currentTab,
                }
            },
            handleShowMore(){
                this.offset += this.limit;
                this.getUserGoalsReport();
            },
            resetReports() {
                this.offset = 0;
                this.reports = [];
            }
        },
        computed: {
            validReports() {
                return this.reports.length > 0;
            }
        },
        components: {
            GoalMenu,
            History,
            TableFixedHeader,
        },
        props: {
        },
        watch: {
            currentTab() {
                this.resetReports();
                if (this.currentTab === 'overview') {
                    this.getUserGoalsOverview();
                } else {
                    this.getUserGoalsReport();
                }
            }
        },
        created() {
            this.getUserGoalsReport();
        },
    });
</script>

<style lang="scss" scoped>
    #app {
        .v-data-table ::v-deep .v-data-table-header {
            background-color: var(--volie-blue) !important;
        }

        .v-data-table ::v-deep .v-data-table-header th {
            color: white !important;
        }
    }
</style>
